import React, { useState, useEffect } from 'react';
import Navigation from './homepage/Navigation';
import HeroSection from './homepage/HeroSection';
import LiveRates from './homepage/LiveRates';
import AboutSection from './homepage/AboutSection';
import ProcessSection from './homepage/ProcessSection';
import FAQSection from './homepage/FAQSection';
import ContactSection from './homepage/ContactSection';
import Footer from './homepage/Footer';
import BackToTop from './homepage/BackToTop';

export default function HomePage() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Navigation />
      <HeroSection />
      <LiveRates />
      <AboutSection />
      <ProcessSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <BackToTop isVisible={isVisible} onClick={scrollToTop} />
    </div>
  );
}
